<template>
  <div class="receiptBaseInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="basicInfo"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import { dateFormatter } from '@/common/js/util';

  export default {
    name: 'basicInfo',
    components: {
      baseForm,
    },
    props: ['canEdit'],
    data() {
      return {
        baseData: {
          ptcombiNo: null, //策略编号
          combiName: null, //策略名称
          exchangeTypeMode: null, //策略模式
          productName: null, //项目名称
          branchNo: null, //业务部门
          branchName: null, //部门名称
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 策略编号
            prop: 'ptcombiNo',
            label: this.$t('futuresStrategy.strategicContract.column.ptcombiNo'),
            type: 'searchTable',
            searchType: 'ptcombiDetail',
            required: true,
            isMultiple: true,
            extraData: {
              strategyFalg: '0', //1查全部,0查部分(未关联合同号)
            },
            currentValue: this.baseData.ptcombiNo,
          },
          //敞口数量
          {
            prop: 'exposureAmount',
            label: this.$t('futuresStrategy.strategicContract.column.exposureAmount'),
            type: 'input',
            disabled: true,
          },
          //敞口金额
          {
            prop: 'exposureBalance',
            label: this.$t('futuresStrategy.strategicContract.column.exposureBalance'),
            type: 'input',
            disabled: true,
          },
          {
            prop: '',
          },
          {
            // 策略名称
            prop: 'combiName',
            label: this.$t('futuresStrategy.strategicContract.column.combiName'),
            type: 'input',
            disabled: true,
            required: true,
          },
          {
            // 策略模式
            prop: 'exchangeTypeMode',
            label: this.$t('futuresStrategy.strategicContract.column.exchangeTypeMode'),
            type: 'dict',
            dictType: 'strategy_model',
            disabled: true,
            required: true,
          },
          {
            // 项目名称
            prop: 'productName',
            label: this.$t('futuresStrategy.strategicContract.column.projectName'),
            type: 'input',
            required: false,
            disabled: true,
          },
          {
            // 业务部门
            prop: 'branchName',
            label: this.$t('futuresStrategy.strategicContract.column.departmentName'),
            type: 'input',
            required: false,
            filterable: true,
            disabled: true,
          },
        ];
      },
    },
    mounted() {
      if (this.$route.name.indexOf('Add') != -1) {
        this.baseData.businessCompanyCode = this.userInfo.companyCode;
        this.baseData.businessCompanyName = this.userInfo.companyName;
        this.baseData.businessDepartmentCode = this.userInfo.departmentCode;
        this.baseData.businessDepartmentName = this.userInfo.departmentName;
        this.baseData.businessUser = this.userInfo.userName;
        this.baseData.createBy = this.userInfo.userCode;
        this.baseData.gmtCreate = dateFormatter(new Date());
      }
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化

        if (prop == 'ptcombiNo') {
          let res = value.ptcombiNo;
          if (res && res.length > 0) {
            this.baseData.ptcombiNo = res[0].ptcombiNo;
            this.baseData.combiName = res[0].combiName;
            this.baseData.exchangeTypeMode = res[0].exchangeTypeMode;
            this.baseData.productName = res[0].productName;
            this.baseData.branchName = res[0].branchName;
            this.baseData.exposureAmount = res[0].exposureAmount;
            this.baseData.exposureBalance = res[0].exposureBalance;
          } else {
            this.baseData.ptcombiNo =
              this.baseData.combiName =
              this.baseData.exchangeTypeMode =
              this.baseData.productName =
              this.baseData.branchName =
              this.baseData.exposureAmount =
              this.baseData.exposureBalance =
                null;
          }
        }
      },

      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.basicInfo.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
